"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConsentCookie = exports.clearConsentCookie = exports.CookieBanner = exports.CONSENT_CODES = void 0;
var _react = require("react");
var _cookie = _interopRequireDefault(require("./cookie.svg"));
require("./styles.css");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DEFAULT_COOKIE_NAME = "COOKIE_CONSENT";
var CONSENT_CODES = {
  GRANTED: "granted",
  DENIED: "denied",
  NOT_SET: "not_set"
};
exports.CONSENT_CODES = CONSENT_CODES;
var CookieBanner = function CookieBanner(props) {
  var showDelayMs = props.showDelayMs,
    _props$bannerText = props.bannerText,
    bannerText = _props$bannerText === void 0 ? "We use cookies to improve your experience" : _props$bannerText,
    _props$headline = props.headline,
    headline = _props$headline === void 0 ? "Cookie policy" : _props$headline,
    _props$linkText = props.linkText,
    linkText = _props$linkText === void 0 ? "More on how we use cookies" : _props$linkText,
    policyLink = props.policyLink,
    _props$acceptText = props.acceptText,
    acceptText = _props$acceptText === void 0 ? "Accept" : _props$acceptText,
    _props$denyText = props.denyText,
    denyText = _props$denyText === void 0 ? "Don't accept" : _props$denyText,
    iconSrc = props.iconSrc,
    _props$showDefaultIco = props.showDefaultIcon,
    showDefaultIcon = _props$showDefaultIco === void 0 ? true : _props$showDefaultIco,
    _props$acceptBtnStyle = props.acceptBtnStyles,
    acceptBtnStyles = _props$acceptBtnStyle === void 0 ? {} : _props$acceptBtnStyle,
    _props$denyBtnStyles = props.denyBtnStyles,
    denyBtnStyles = _props$denyBtnStyles === void 0 ? {} : _props$denyBtnStyles,
    _props$linkStyles = props.linkStyles,
    linkStyles = _props$linkStyles === void 0 ? {} : _props$linkStyles,
    _props$bannerStyles = props.bannerStyles,
    bannerStyles = _props$bannerStyles === void 0 ? {} : _props$bannerStyles,
    _props$headlineStyles = props.headlineStyles,
    headlineStyles = _props$headlineStyles === void 0 ? {} : _props$headlineStyles,
    _props$textStyles = props.textStyles,
    textStyles = _props$textStyles === void 0 ? {} : _props$textStyles,
    _props$withAnimation = props.withAnimation,
    withAnimation = _props$withAnimation === void 0 ? true : _props$withAnimation,
    _props$ttlDays = props.ttlDays,
    ttlDays = _props$ttlDays === void 0 ? 90 : _props$ttlDays,
    _props$cookieName = props.cookieName,
    cookieName = _props$cookieName === void 0 ? DEFAULT_COOKIE_NAME : _props$cookieName,
    onAcceptClick = props.onAcceptClick,
    onDenyClick = props.onDenyClick;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setVisible = _useState2[1];
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setVisible(getConsentCookie(cookieName) === CONSENT_CODES.NOT_SET);
    }, showDelayMs);
  }, [showDelayMs, cookieName]);
  var onAccept = function onAccept() {
    setCookie(cookieName, CONSENT_CODES.GRANTED, ttlDays);
    setVisible(false);
    if (onAcceptClick) {
      onAcceptClick();
    }
  };
  var onDeny = function onDeny() {
    setCookie(cookieName, CONSENT_CODES.DENIED, ttlDays);
    setVisible(false);
    if (onDenyClick) {
      onDenyClick();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "".concat(withAnimation ? "cookieBanner" : "cookieWithoutAnimation", " ").concat(isVisible ? "show" : null),
    style: bannerStyles,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "headline",
      children: [iconSrc || showDefaultIcon ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        className: "icon",
        src: iconSrc !== null && iconSrc !== void 0 ? iconSrc : _cookie["default"],
        alt: "cookie-icon"
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
        style: headlineStyles,
        children: headline
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text",
      style: textStyles,
      children: bannerText
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "buttons",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "deny",
        onClick: onDeny,
        style: denyBtnStyles,
        children: denyText
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        style: acceptBtnStyles,
        className: "accept",
        onClick: onAccept,
        children: acceptText
      })]
    }), policyLink ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "policyLinkContainer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        style: linkStyles,
        className: "policyLink",
        href: policyLink,
        children: linkText
      })
    }) : null]
  });
};
exports.CookieBanner = CookieBanner;
var getConsentCookie = function getConsentCookie() {
  var cname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COOKIE_NAME;
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return CONSENT_CODES.NOT_SET;
};
exports.getConsentCookie = getConsentCookie;
var clearConsentCookie = function clearConsentCookie() {
  var cname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COOKIE_NAME;
  return setCookie(cname, CONSENT_CODES.NOT_SET, 1);
};
exports.clearConsentCookie = clearConsentCookie;
var setCookie = function setCookie(cname, cvalue, ttlDays) {
  var d = new Date();
  d.setTime(d.getTime() + ttlDays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};